import thum1 from '../assest/thumb1.webp';
import thum2 from '../assest/thumb2.webp';
import thum3 from '../assest/thumb3.webp';
import thum4 from '../assest/thumb4.webp';
import thum5 from '../assest/thump5.webp';
import thum6 from '../assest/thumb6.webp';
import thum7 from '../assest/thumb7.webp';
import thum8 from '../assest/thumb8.webp';
import thum9 from '../assest/thumb9.webp';
import thum10 from '../assest/thumb10.webp';
import thum11 from '../assest/thumb11.webp';
import thum12 from '../assest/thumb12.webp';
import thum13 from '../assest/thumb13.webp';
import thum14 from '../assest/thumb14.webp';
import thum15 from '../assest/thumb15.webp';
import thum16 from '../assest/thumb16.webp';
import thum17 from '../assest/thumb17.webp';
import thum18 from '../assest/thumb18.webp';
import thum19 from '../assest/thumb19.webp';
import thum20 from '../assest/thumb20.webp';
import thum21 from '../assest/thumb21.webp';
import thum22 from '../assest/thumb22.webp';
import thum23 from '../assest/thumb23.webp';
import thum24 from '../assest/thumb24.webp';
import thum25 from '../assest/thumb25.webp';
import thum26 from '../assest/thumb26.webp';
import thum27 from '../assest/thumb27.webp';
import thum28 from '../assest/thumb28.webp';
import thum29 from '../assest/thumb29.webp';
import thum30 from '../assest/thumb30.webp';
import thum31 from '../assest/thumb31.webp';
import thum32 from '../assest/thumb32.webp';
import thum33 from '../assest/thumb33.webp';
import thum34 from '../assest/thumb34.webp';
import thum35 from '../assest/thumb35.webp';
import thum36 from '../assest/thumb36.webp';
import thum37 from '../assest/thumb37.webp';
import thum38 from '../assest/thumb38.webp';
import thum39 from '../assest/thumb39.webp';
import thum40 from '../assest/thumb40.webp';
import thum41 from '../assest/thumb41.webp';
import thum42 from '../assest/thumb42.webp';
import thum44 from '../assest/thumb44.webp';
import thum45 from '../assest/thumb45.webp';
import thum46 from '../assest/thumb46.webp';
import thum47 from '../assest/thumb47.webp';
import thum48 from '../assest/thumb48.webp';





export const PROJECTS = [
  {
    id: 1,
    type: 'video',
    thumbnail: thum1,
    videoId: 'MCSDReN0u6c',
    category: 'Batch Photoday',
    title: 'Higher National Diploma in Food Technology 2025',
    description: 'A video from the 2025 Higher National Diploma in Food Technology batch photoday.'
  },
  {
    id: 2,
    type: 'image',
    thumbnail: thum2,
    fullRes: thum2,
    category: 'Poster',
    title: 'Job Vacancy',
    description: 'A recruitment poster created to share a job vacancy.'
  },
  {
    id: 3,
    type: 'video',
    thumbnail: thum40,
    videoId: '6MeQ6U5yyms',
    category: 'Batch Photoday',
    title: 'Higher National Diploma in Food Technology 2026',
    description: 'A video from the 2026 Higher National Diploma in Food Technology batch photoday.'
  },
  {
    id: 4,
    type: 'video',
    thumbnail: thum41,
    videoId: 'pYy0QHFA6pY',
    category: 'Video',
    title: 'Model Shoot',
    description: 'A video project featuring a model shoot.'
  },
  {
    id: 43,
    type: 'video',
    thumbnail: thum34,
    videoId: 'ILSezOayNPQ',
    category: 'Social Meadi Post',
    title: 'New Year Post'
  },
  {
    id: 45,
    type: 'video',
    thumbnail: thum45,
    videoId: 'DlKGvxqvu_M',
    category: 'Company Profile',
    title: 'Advertisement'
  },
  {
    id: 46,
    type: 'video',
    thumbnail: thum46,
    videoId: '_bMJqSX2VXY',
    category: 'Company Profile',
    title: 'Advertisement'
  },
    {
    id: 47,
    type: 'video',
    thumbnail: thum47,
    videoId: 'fMDCN_XeLXA',
    category: 'Company Profile',
    title: 'Advertisement'
  },
  {
    id: 48,
    type: 'video',
    thumbnail: thum48,
    videoId: 'OQLsNRXqpLs',
    category: 'Company Profile',
    title: 'Advertisement'
  },
    {
    id: 49,
    type: 'video',
    thumbnail: thum24,
    videoId: 'rbPHVs8pvjg',
    category: 'Company Profile',
    title: 'Advertisement'
  },
  {
    id: 5,
    type: 'image',
    thumbnail: thum3,
    fullRes: thum3,
    category: 'Social Media Post',
    title: 'Valentine Day'
  },
  {
    id: 6,
    type: 'image',
    thumbnail: thum4,
    fullRes: thum4,
    category: 'Branding',
    title: 'Product Poster'
  },
  {
    id: 7,
    type: 'image',
    thumbnail: thum7,
    fullRes: thum7,
    category: 'Notice',
    title: 'Happy New Year Poster'
  },
  {
    id: 8,
    type: 'image',
    thumbnail: thum8,
    fullRes: thum8,
    category: 'Banner',
    title: 'Happy Sinhala and Tamil New Year'
  },
  {
    id: 9,
    type: 'image',
    thumbnail: thum10,
    fullRes: thum10,
    category: 'Social Media Post',
    title: 'Celebration'
  },
  {
    id: 10,
    type: 'video',
    thumbnail: thum5,
    videoId: 'dXQz6xBPR-o',
    category: 'Social Media Post',
    title: 'Social Media Post'
  },
  {
    id: 11,
    type: 'video',
    thumbnail: thum23,
    videoId: 'zKmk-BrZGMI',
    category: 'Social Media Post',
    title: 'New year Post'
  },
  {
    id: 12,
    type: 'video',
    thumbnail: thum22,
    videoId: 'IAIU0aP74Lo',
    category: 'Motion Graphics',
    title: 'New year Post'
  },
  {
    id: 13,
    type: 'video',
    thumbnail: thum9,
    videoId: 'S3sp0GhFys8',
    category: 'Video Creation',
    title: 'Water Day Video'
  },
  {
    id: 14,
    type: 'video',
    thumbnail: thum42,
    videoId: 'oolLTbWLtGY',
    category: 'Company Profile',
    title: 'Devine nature Tea Company'
  },
  {
    id: 15,
    type: 'image',
    thumbnail: thum11,
    fullRes: thum11,
    category: 'Branding',
    title: 'Price List'
  },
  {
    id: 16,
    type: 'image',
    thumbnail: thum12,
    fullRes: thum12,
    category: 'Branding',
    title: 'Head band Design'
  },
  {
    id: 17,
    type: 'image',
    thumbnail: thum13,
    fullRes: thum13,
    category: 'Social Meadia Post',
    title: 'Product Poster'
  },
  {
    id: 18,
    type: 'image',
    thumbnail: thum14,
    fullRes: thum14,
    category: 'Social Meadia Post',
    title: 'Product Poster'
  },
  {
    id: 19,
    type: 'image',
    thumbnail: thum15,
    fullRes: thum15,
    category: 'Social Meadia Post',
    title: 'Product Poster'
  },
  {
    id: 20,
    type: 'image',
    thumbnail: thum16,
    fullRes: thum16,
    category: 'Social Meadia Post',
    title: 'Product Poster'
  },
  {
    id: 21,
    type: 'image',
    thumbnail: thum17,
    fullRes: thum17,
    category: 'Branding',
    title: 'Inside Video'
  },
  {
    id: 22,
    type: 'image',
    thumbnail: thum18,
    fullRes: thum18,
    category: 'Social Poster',
    title: 'Happy Easter Day'
  },
  {
    id: 23,
    type: 'image',
    thumbnail: thum19,
    fullRes: thum19,
    category: 'Social Poster',
    title: 'Easter Day Poster'
  },
  {
    id: 24,
    type: 'image',
    thumbnail: thum20,
    fullRes: thum20,
    category: 'Social Poster',
    title: 'World Heath Day'
  },
  {
    id: 25,
    type: 'image',
    thumbnail: thum21,
    fullRes: thum21,
    category: 'Social Poster',
    title: 'World Heath Day'
  },
  {
    id: 26,
    type: 'image',
    thumbnail: thum25,
    fullRes: thum25,
    category: 'Banner',
    title: 'Banner'
  },
  {
    id: 27,
    type: 'image',
    thumbnail: thum26,
    fullRes: thum26,
    category: 'Social Poster',
    title: 'World Earth Day'
  },
  {
    id: 28,
    type: 'image',
    thumbnail: thum27,
    fullRes: thum27,
    category: 'Social Poster',
    title: 'Product Post'
  },
  {
    id: 29,
    type: 'image',
    thumbnail: thum28,
    fullRes: thum28,
    category: 'Catelogue',
    title: 'Cover Page'
  },
  {
    id: 30,
    type: 'image',
    thumbnail: thum29,
    fullRes: thum29,
    category: 'Social Media Post',
    title: 'Product Poster'
  },
  {
    id: 31,
    type: 'image',
    thumbnail: thum30,
    fullRes: thum30,
    category: 'Social Media Post',
    title: 'Product Poster'
  },
  {
    id: 32,
    type: 'image',
    thumbnail: thum31,
    fullRes: thum31,
    category: 'Social Media Post',
    title: 'Happy Easter'
  },
  {
    id: 33,
    type: 'image',
    thumbnail: thum32,
    fullRes: thum32,
    category: 'Social Media Post',
    title: 'World Heath Day'
  },
  {
    id: 34,
    type: 'image',
    thumbnail: thum33,
    fullRes: thum33,
    category: 'Social Media Post',
    title: 'World Earth Day'
  },
  {
    id: 35,
    type: 'image',
    thumbnail: thum34,
    fullRes: thum34,
    category: 'Social Media Post',
    title: 'Happy New Year'
  },
  {
    id: 36,
    type: 'image',
    thumbnail: thum35,
    fullRes: thum35,
    category: 'Social Media Post',
    title: 'World Earth Day'
  },
  {
    id: 37,
    type: 'image',
    thumbnail: thum36,
    fullRes: thum36,
    category: 'Social Media Post',
    title: 'World Earth Day'
  },
  {
    id: 38,
    type: 'image',
    thumbnail: thum37,
    fullRes: thum37,
    category: 'Social Media Post',
    title: 'Labour Day'
  },
  {
    id: 39,
    type: 'image',
    thumbnail: thum38,
    fullRes: thum38,
    category: 'Social Media Post',
    title: 'Mother Day'
  },
  {
    id: 40,
    type: 'image',
    thumbnail: thum39,
    fullRes: thum39,
    category: 'Social Media Post',
    title: 'Tuna Day'
  },
  {
    id: 41,
    type: 'video',
    thumbnail: thum6,
    videoId: '_i0aMN1Kd8Q',
    category: 'Social Meadi Post',
    title: 'Eid Mubarak'
  },
  {
    id: 42,
    type: 'image',
    thumbnail: thum23,
    fullRes: thum23,
    category: 'Social Media Post',
    title: 'New Year'
  },
  {
    id: 44,
    type: 'image',
    thumbnail: thum44,
    fullRes: thum44,
    category: 'Branding',
    title: 'Product Post'
  },

];  
